import React,{useState} from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Button,
  TextField,
} from "@mui/material";
import Clothcard from "./Clothcard";
import { winteritems } from "./winteritem";
const Winterclothcollection = (props) => {
    const [search, setSearch]=useState("")
  return (
    <React.Fragment>
      <Typography
        sx={{
          background: `linear-gradient(#212245b2,#212245b2),url("winter.jpg")`,
          textAlign: "center",
          backgroundRepeat: "no-repeat",
          padding: "80px 0",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "120px",
          color: "white",
          fontSize: "1.8rem",mt:8
        }}
      >Winter Warmth, Style Untamed: Explore our Cozy Winter Collection
      </Typography>
      <Container>
        <Box sx={{mt:5}}>
          <Typography sx={{ fontSize: "1.3rem", textAlign: "center" }}>
            Search For Your Clothes
          </Typography>
          <TextField
            sx={{
              mt: 2,
              justifyContent: "center",
              marginLeft: { lg: 45, xs:6, md: 45,sm:29 },
              width: { lg: "55ch", xs: "30ch" },
            }}
            placeholder="gloves"
            onChange={(e)=>setSearch(e.target.value)}
          ></TextField>
        </Box>
        <Grid container spacing={5}>
          {winteritems.filter((item)=>{const searchQuery=search.toLocaleLowerCase();
          const itemDescription=item.name.toLocaleLowerCase();
        return searchQuery == "" || itemDescription.includes(searchQuery)
        }).map((item, index) => (
            <Grid item lg={3} md={4} xs={12}>
              <Clothcard
               key={index}
               item={item}
                img={item.image}
                name={item.name}
                price={item.price}
                description={item.description}
                size1={item.size1}
                size2={item.size2}
                size3={item.size3}
                size4={item.size4}
                brand={item.brand}
                color1={item.color1}
                color2={item.color2}
                id={item.id}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default Winterclothcollection;
